// extracted by mini-css-extract-plugin
module.exports = {"root":"ReturnLink_root__d_qPf","icon":"ReturnLink_icon__pGqL8"};